import { ActionContext, ActionTree } from 'vuex'
import { mutationType } from './mutation-types'
import ThisState, { List } from './states'
import _ from 'lodash'
import { State } from '@/store/store'
import httpRequest from '@/services/HttpRequestServiceWithToken'

const actions: ActionTree<ThisState, State> = {
  async initList(
    { commit, dispatch, state }: ActionContext<ThisState, State>,
    options: object,
  ): Promise<void> {
    const initList: List = {
      column: [],
      page: 1,
      pageCount: 1,
      result: [],
      defaultFilter: [],
      itemCount: 0,
    }
    commit(mutationType.GET_LISTS, initList)
  },
  async getIncomeCaregiverList(
    { commit, dispatch, state }: ActionContext<ThisState, State>,
    options: object,
  ): Promise<void> {
    await httpRequest
      .getByLevel(process.env.VUE_APP_API_URL + '/v1', 'report/income/caregiver', options, (res: List) => {
        commit(mutationType.GET_LISTS, res)
      })
  },
  async getIncomeCenterList(
    { commit, dispatch, state }: ActionContext<ThisState, State>,
    options: object,
  ): Promise<void> {
    await httpRequest
      .getByLevel(process.env.VUE_APP_API_URL + '/v1', 'report/income/center', options, (res: List) => {
        commit(mutationType.GET_LISTS, res)
      })
  },
}

export default actions
